import i18n from "@src/i18n";

const getNumberBetType = (val) => {
  switch(val){
    case "NEXT_BALL_OVER": return i18n.t('BIG');
    case "NEXT_BALL_UNDER": return i18n.t('SMALL');
    case "NEXT_BALL_ODD": return i18n.t('ODD');
    case "NEXT_BALL_EVEN": return i18n.t('EVEN');
    case "NEXT_BALL_RED": return i18n.t('RED');
    case "NEXT_BALL_BLUE": return i18n.t('BLUE');
    case "NEXT_BALL_UE": return i18n.t('result_type.UNDER_EVEN');
    case "NEXT_BALL_UO": return i18n.t('result_type.UNDER_ODD');
    case "NEXT_BALL_OE": return i18n.t('result_type.OVER_EVEN');
    case "NEXT_BALL_OO": return i18n.t('result_type.OVER_ODD');
    default: return val.replace('NUMBER_', '')
      .replace('COL_', 'C')
      .replace('ROW_', '');
  }
}

export const getBetTypeValue = (game, val) => {
  // console.log('getBetTypeValue', game, val);
  switch(game){
    case "number_game":
      return getNumberBetType(val);
    default:
      return val;
  }
}

const getNumberBetTypeGroup = (val) => {
  switch(val){
    case "NEXT_BALL_UNDER":
    case "NEXT_BALL_OVER": return i18n.t('result_type.BIG_SMALL');
    case "NEXT_BALL_ODD":
    case "NEXT_BALL_EVEN": return i18n.t('result_type.ODD_EVEN');
    case "NEXT_BALL_RED":
    case "NEXT_BALL_BLUE": return i18n.t('result_type.RED_BLUE');
    case "NEXT_BALL_UE":
    case "NEXT_BALL_UO":
    case "NEXT_BALL_OE":
    case "NEXT_BALL_OO": return i18n.t('result_type.COMBO');
    case "COL_1":
    case "COL_2":
    case "COL_3":
    case "COL_4":
    case "COL_5": return i18n.t('result_type.COLUMN_BET');
    case "ROW_R1_01_05":
    case "ROW_R1_06_10":
    case "ROW_R1_11_15":
    case "ROW_R1_16_20":
    case "ROW_R1_21_25": 
    case "ROW_R1_26_30": 
    case "ROW_R1_31_35": 
    case "ROW_R1_36_40": 
    case "ROW_R1_41_45": 
    case "ROW_R1_46_50": 
    case "ROW_R1_51_55": 
    case "ROW_R1_56_60": 
    case "ROW_R1_61_65": 
    case "ROW_R1_66_70": 
    case "ROW_R1_71_75": return i18n.t('result_type.ROW_1_BET');
    case "ROW_R3_01_15":
    case "ROW_R3_16_30":
    case "ROW_R3_31_45":
    case "ROW_R3_46_60": 
    case "ROW_R3_61_75": return i18n.t('result_type.ROW_3_BET');
    case "ROW_R5_01_25":
    case "ROW_R5_26_50":
    case "ROW_R5_51_75":return i18n.t('result_type.ROW_5_BET');
    default: return i18n.t('result_type.SINGLE_BET');
  }
}


export const getBetTypeGroupValue = (game, val) => {
  // console.log('getBetTypeGroup', game, val);
  switch(game){
    case "number_game":
      return getNumberBetTypeGroup(val);
    default:
      return val;
  }
}